/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState} from "react";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import TableHeader from "../Common/TableHeader";
import Loader from "../Common/Loader";
import TransactionsTable from "../Common/Transactions/TransactionsTable";
import Pagination from "../Common/Pagination";
import ajaxBank from "../../util/remote/ajaxBank";
import PMTransactionsSearchForm from "../Common/Transactions/PMTransactionsSearchForm";

function PMoneyTransactions() {
  const [pmTransactions, setPMTransactions] = useState(false);
  const [pmSearchTerm, setPmSearchTerm] = useState("");
  const [pmStartDate, setPmStartDate] = useState("");
  const [pmEndDate, setPmEndDate] = useState("");
  const [pmPage,setPmPage] = useState(1)
  const [pmMeta,setPmMeta] = useState([])
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [type, setType] = useState("");
  
  useEffect(() => {
    if (pmSearchTerm || pmStartDate || pmEndDate || type) {
      searchPMTransactions();
    } else {
      fetchPMTransactions(pmPage);
    }
  }, [pmPage]);

  const fetchPMTransactions = async (currentPage) => {
    setLoading(true);
    const response = await ajaxBank.fetchPMTransactions(currentPage);
    setLoading(false);
    if (response.status === "OK") {
      setPmMeta(response.details.meta.totalPages);
      setPMTransactions(response.details.data || []);
    } else {
      setPMTransactions([]);
    }
  };


  const searchPMTransactions = async (e) => {
    if (e) e.preventDefault();
    setLoading2(true);

    const response = await ajaxBank.searchPMTransactions(pmPage, pmStartDate, pmEndDate, pmSearchTerm, type);
    setLoading2(false);
    if (response.status === "OK") {
      setPmMeta(response.details.meta.totalPages);
      setPMTransactions(response.details.data || []);
    } else {
      setPMTransactions([]);
    }
  };
  const resetFilters = (e) => {
    e.preventDefault();
    setPmSearchTerm("");
    setPmStartDate("");
    setPmEndDate("");
    setPmPage(1);
    setType("");
    fetchPMTransactions(1);
  };

  const exportToPDF = () => {
    const pdf = new jsPDF("p", "pt", "a4");
    const columns = ["Date & Time", "User", "Transaction Number", "Amount"];
    const data = pmTransactions.map(item => [
      `${item.created_at?.short_date} ${item.created_at?.time}`,
      `${item.user} (${item.username})`,
      item.phone_number,
      `UGX. ${item.amount}`,
    ]);

    pdf.autoTable({ head: [columns], body: data });
    pdf.save("pkt_money_data.pdf");
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= pmMeta) {
      setPmPage(newPage);
    }
  };

  const headers = [
    { label: "Transaction Date", key: "created_at" },
    { label: "Transaction Number", key: "transaction_number" },
    { label: "Amount", key: "amount" },
    { label: "Transactors", key: "transactors"},
    { label: "Transaction Type", key:"account"}

  ];

  

  return (
    <>
      <div className="heading-layout1 mg-b-5">
        <TableHeader
            subtitle="List of all the pocket money transactions made sorted by the most recent"
        />
        <div className="dropdown">
          <Link className="dropdown-toggle" role="button" data-toggle="dropdown">...</Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" onClick={exportToPDF}>
              <i className="fas fa-file-export"></i>Export
            </Link>
          </div>
        </div>
      </div>

      {/* <TransactionsSearchForm searchTerm={pmSearchTerm} setSearchTerm={setPmSearchTerm} startDate={pmStartDate}
         setStartDate={setPmStartDate} endDate={pmEndDate} setEndDate={setPmEndDate} searchTransactions={searchPMTransactions}
         setTransactions={resetFilters} setPage={setPmPage} searchTermPlaceholder="Enter transaction number..."/> */}

      <PMTransactionsSearchForm searchTerm={pmSearchTerm} type={type} setSearchTerm={setPmSearchTerm} setType={setType} startDate={pmStartDate}
         setStartDate={setPmStartDate} endDate={pmEndDate} setEndDate={setPmEndDate} searchTransactions={searchPMTransactions}
         resetSearch={resetFilters} setPage={setPmPage}/>
      <div className="border-top mt-3"></div>
      <div className="table-responsive">
        {loading || loading2 ? (
          <Loader />
        ) : (
          <TransactionsTable headers={headers} data={pmTransactions} isPMTransaction={true}/>
        )}
      </div>

      <Pagination currentPage={pmPage} totalPages={pmMeta} onPageChange={handlePagination}/>

    </>
  );
}

export default PMoneyTransactions;